import { VoyageRoute } from "../../models/voyage-routing-model";

export enum Format
{
    SPOS = "SPOS",
    Nacos = "Nacos",
    RTE = "RTE",
    RTZ_1_0 = "RTZ 1.0",
    RTZ_1_1 = "RTZ 1.1",
    RTZ_1_2 = "RTZ 1.2",
    RTZ_2_0 = "RTZ 2.0",
    Sperry = "Sperry",
    JRC = "JRC",
    VoyagePlanning = "VoyagePlanning",
    SPOS_Pilot = "SPOS PilotToPilot",
    BasicPlan = "BasicPlan",
}

export interface ExportResult
{
    data?: string;
    mimeType: string;
    fileExt: string;
}

export interface ImportResult
{
    route: VoyageRoute;
    extras: {[index:string]: any };
}
